import { useMemo } from 'react';
import { CustomTheme } from '../types';

export interface UseChatSubmitLabelParams {
  theme: CustomTheme;
  t: (key: string) => string;
}

export interface UseChatSubmitLabelResult {
  chatSubmitButtonLabel: string | undefined;
}

/**
 * Hook to compute the chat submit button label from CSS custom properties
 * The label key is set via --theme-chat-submit-button-label-key CSS variable
 */
export const useChatSubmitLabel = ({
  theme,
  t,
}: UseChatSubmitLabelParams): UseChatSubmitLabelResult => {
  const chatSubmitButtonLabelKey = useMemo(() => {
    if (typeof window === 'undefined') return;
    return getComputedStyle(document.documentElement)
      .getPropertyValue('--theme-chat-submit-button-label-key')
      .trim();
  }, [theme]); // theme change means the custom styles are loaded

  const chatSubmitButtonLabel = useMemo(() => {
    return chatSubmitButtonLabelKey ? t(chatSubmitButtonLabelKey) : undefined;
  }, [chatSubmitButtonLabelKey, t]);

  return { chatSubmitButtonLabel };
};
